
import { computed, defineComponent } from 'vue'
import { useBillingStore } from '../../../../store/stores/billing'
import { getAvailableSubscriptionPeriods } from '../../subscriptionPeriodDiscount'
import { describeAmountPromocode } from './activePromocode'

export default defineComponent({
    props: {
        tariffId: { type: String, required: true },
        recommended: { type: Boolean, default: false },
    },
    setup(props) {
        const billingStore = useBillingStore()
        const tariff = computed(() => billingStore.getTariffById(props.tariffId))
        const isSelected = computed(() => billingStore.selectedTariffId === props.tariffId)
        const tariffPromocode = computed(() => billingStore.getTariffPromocode(props.tariffId))
        const amountPromocodeNote = computed(() => describeAmountPromocode(tariffPromocode.value))
        const isPeriodAvailable = computed(() => {
            const period = billingStore.selectedSubscriptionPeriod
            if (!period) return false
            return getAvailableSubscriptionPeriods(tariff.value ?? null).includes(period)
        })
        const price = computed(() => {
            if (!isPeriodAvailable.value) return 0
            const periodInMonth = parseInt(billingStore.selectedSubscriptionPeriod!) || 0
            if (!periodInMonth) return 0
            return Math.round(
                billingStore.getTarrifRegularPrice(props.tariffId, billingStore.selectedSubscriptionPeriod!) / periodInMonth
            )
        })
        const promoPrice = computed(() => {
            if (!isPeriodAvailable.value) return 0
            const periodInMonth = parseInt(billingStore.selectedSubscriptionPeriod!) || 0
            if (!periodInMonth) return 0
            return Math.round(
                billingStore.getTarrifPromoPrice(props.tariffId, billingStore.selectedSubscriptionPeriod!) / periodInMonth
            )
        })
        // Зачёркнутая цена — для процента, и только если billing дал скидку этому тарифу.
        const showPromoPrice = computed(
            () =>
                Boolean(tariffPromocode.value) && !amountPromocodeNote.value && promoPrice.value < price.value
        )
        const formattedPrice = computed(() => billingStore.formatPrice(price.value))
        const formattedPromoPrice = computed(() => billingStore.formatPrice(promoPrice.value))
        const priceDescription = computed(() => {
            switch (billingStore.selectedSubscriptionPeriod) {
                case '1': return 'в месяц, первое списание будет за 2 месяца'
                case '3': return 'в месяц, при оплате за 3 месяца'
                case '6': return 'в месяц, при оплате за 6 месяцев'
                case '12': return 'в месяц, при оплате за 12 месяцев'
                case '24': return 'в месяц, при оплате за 24 месяца'
                default: return ''
            }
        })
        const selectTariff = () => {
            if (isSelected.value) return
            billingStore.selectedTariffId = props.tariffId
        }
        return {
            tariff,
            isSelected,
            isPeriodAvailable,
            selectTariff,
            formattedPrice,
            formattedPromoPrice,
            showPromoPrice,
            amountPromocodeNote,
            priceDescription,
        }
    },
})
